import { isValidTckn } from 'src/app/core/helpers/identity-document.helpers';
import { FrontSideResult } from './identity-ocr.models';

/**
 * T.C. Kimlik Kartı ön yüzü OCR metninden alan çıkarımı. Etiketlere (Soyadı, Adı…) güvenilmez —
 * zemin ve hologram gürültüsü etiket satırlarını bozuyor (Faz 0 spike); bunun yerine alanların
 * kendi biçimi aranır: algoritmaya uyan 11 hane, A12B34567 seri no, GG.AA.YYYY tarihler.
 */
export function parseFrontSide(text: string, today: Date = new Date()): FrontSideResult {
  const tckn = (text.match(/\b\d{11}\b/g) ?? []).find(isValidTckn);
  const serialNumber = text.match(/\b[A-Z]\d{2}[A-Z]\d{5}\b/)?.[0];

  // Ön yüzde iki tarih var: doğum tarihi ve son geçerlilik — küçük olan doğum tarihi.
  const dates = (text.match(/\b\d{2}[.,]\d{2}[.,]\d{4}\b/g) ?? [])
    .map((d) => d.replace(/,/g, '.').split('.'))
    .filter(([dd, mm]) => +dd >= 1 && +dd <= 31 && +mm >= 1 && +mm <= 12)
    .map(([dd, mm, yyyy]) => `${yyyy}-${mm}-${dd}`)
    .sort();
  const unique = Array.from(new Set(dates));
  let birthDate = unique.length > 1 ? unique[0] : undefined;
  let expiryDate = unique.length > 1 ? unique[unique.length - 1] : undefined;
  if (unique.length === 1) {
    // Tek tarih okunduysa hangisi olduğu belli değil: gelecekteki tarih son geçerlilik, en az 15 yıl
    // önceki doğum tarihi; arada kalan hiçbirine yazılmaz.
    const pad = (n: number) => String(n).padStart(2, '0');
    const todayText = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    const adultLimit = `${today.getFullYear() - 15}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    if (unique[0] >= todayText) expiryDate = unique[0];
    else if (unique[0] <= adultLimit) birthDate = unique[0];
  }

  const upperWords = Array.from(new Set(text.match(/[A-ZÇĞİÖŞÜ]{2,}/g) ?? []));
  return { tckn, serialNumber, birthDate, expiryDate, upperWords };
}
